import auth from 'src/router/auth'

import CheckServiceGhn from '../CheckServiceGhn'
export default [
  {
    path: '/check-ghn-service',
    name: 'check-ghn-service',
    component: CheckServiceGhn,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/checkservice/routes/index.js